<template>
  <div id="list-video" class="list-dispo">
    <vue-topprogress
      ref="topProgress"
      style="position: relative;right: 0px;height: 7px;"
    ></vue-topprogress>
    <b-row>
      <div class="modal-body-content-module">
        <div id="plan1">
          <b-row>
            <b-card id="card-add-prog">
              <div class="icon-add-prog">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 30 30">
                  <path
                    id="Color"
                    d="M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z"
                    transform="translate(3.75 3.75)"
                    fill="#acadb1"
                  />
                </svg>
              </div>
              <div class="text-left">
                <h4>{{ $t('module.generic.title') }}</h4>
                <h6 style="color: #68686b">
                  {{ $t('module.generic.textAdd') }} {{ $t('blocks.add_generic_' + genericType) }}
                </h6>
              </div>
            </b-card>
          </b-row>
          <div id="list_video">
            <b-row>
              <div id="search-list" class="search-wrapper-list">
                <b-row>
                  <b-col>
                    <b-input-group class="search-group">
                      <b-input-group-append class=" search-icon" v-on:click="searchVideo(true)">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="1.5em"
                          height="1.5em"
                          viewBox="0 0 40 40"
                        >
                          <path
                            id="Color"
                            d="M28.879,28.929a1.083,1.083,0,0,1-.76-.305l-6.96-6.712v-.072A13.25,13.25,0,0,1,7.772,23.775,12.758,12.758,0,0,1,3.4,20.785,12.074,12.074,0,0,1,3.763,3.629a13.2,13.2,0,0,1,17.791-.352A12.079,12.079,0,0,1,22.648,20.4h.075l6.96,6.712a1.007,1.007,0,0,1-.043,1.507A1.1,1.1,0,0,1,28.879,28.929ZM12.857,2.143A10.468,10.468,0,0,0,2.143,12.321a9.863,9.863,0,0,0,3.138,7.2A10.935,10.935,0,0,0,12.857,22.5a11.15,11.15,0,0,0,4.1-.775,10.724,10.724,0,0,0,3.476-2.206,10.11,10.11,0,0,0,2.322-3.3,9.7,9.7,0,0,0,.815-3.9,9.862,9.862,0,0,0-3.138-7.2A10.934,10.934,0,0,0,12.857,2.143Z"
                            transform="translate(5 6)"
                            fill="#7c7c7c"
                          />
                        </svg>
                      </b-input-group-append>
                      <b-form-input
                        class="inputSearch"
                        :placeholder="$t('placeholder.search')"
                        id="inputSearch"
                        v-on:keyup.enter="searchVideo(true)"
                        v-model="textToSearch"
                      ></b-form-input>
                      <div
                        id="close-module-list"
                        class="close-module-list"
                        @click="searchVideo(false)"
                      >
                        <i class="icon-close"></i>
                      </div>
                    </b-input-group>

                    <!--<b-input-group>-->
                    <!--<b-form-input-->
                    <!--:placeholder="$t('placeholder.search')"-->
                    <!--id="inputVideoSearch"-->
                    <!--class="searchInput"-->
                    <!--v-on:keyup.enter="searchVideo()"-->
                    <!--&gt;</b-form-input>-->
                    <!--<b-input-group-append>-->
                    <!--<b-button v-on:click="searchVideo()" class="searchIcon" variant="secondary"-->
                    <!--&gt;<i class="fa fa-search"></i-->
                    <!--&gt;</b-button>-->
                    <!--</b-input-group-append>-->
                    <!--</b-input-group>-->
                  </b-col>
                  <b-col v-show="showSelect">
                    <b-form-select
                      class="mb-3"
                      v-model="idSelectedTheme"
                      @change="onChangeThemId()"
                    >
                      <template slot="first">
                        <option
                          v-for="option in this.options"
                          :value="option.title"
                          :key="option.id"
                          v-bind:value="option.id"
                        >
                          {{ option.title }}
                        </option>
                      </template>
                    </b-form-select>
                  </b-col>
                </b-row>
              </div>
            </b-row>
            <b-row class="list-generics">
              <div class="list-generic-videos">
                <div v-for="(video, index) in all_video" class="video-wrapper">
                  <div
                    v-bind:class="[
                      'video-tag',
                      'video-tag-' + index,
                      {
                        'is-selected-video':
                          selected_vid === video.id || (!selected_vid && isSelected(video)),
                      },
                    ]"
                    v-on:click="SelectVideo(video, index)"
                  >
                    <div class="image-card">
                      <div class="image-card__video">
                        <img
                          v-if="video.logo"
                          :src="video.logo"
                          :id="video.id"
                          class="img-liste-dispo"
                        />
                        <img
                          v-else
                          :src="defaultScreenshot"
                          alt="alt_img"
                          :id="video.id"
                          class="img-liste-dispo"
                        />
                      </div>
                    </div>
                    <div
                      :title="video.duration"
                      class=" image-card__infos__duration duration-style"
                    >
                      {{ duration(video.duration) }}
                    </div>
                    <div :title="video.title" class=" image-card__infos__title">
                      {{ video.title }}
                    </div>
                  </div>
                </div>
              </div>
              <div id="loader-liste-dispo" class=" center">
                <span>
                  <infinite-loading spinner="bubbles"></infinite-loading>
                </span>
              </div>
            </b-row>
          </div>

          <b-row class="position-buttons">
            <button
              :class="['btn btn-outline-secondary', 'footer-select-button']"
              v-on:click="closeGenericList()"
            >
              {{ $t('button.back') }}
            </button>
            <button
              v-if="genericType === 'fin'"
              :class="['btn btn-primary', 'footer-select-button']"
              v-on:click="addGeneriqueVideo()"
              :disabled="disabledSelectButton"
            >
              {{ $t('button.select') }}
            </button>
          </b-row>
        </div>
      </div>
    </b-row>
  </div>
</template>
<script>
import { HTTP } from '../core/http/http-token';
import Routing from '../core/router/router';
import { mapGetters, mapActions } from 'vuex';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
import i18n from '../i18n';
import mixin from '../mixins/Mixin.js';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  mixins: [mixin],
  data() {
    return {
      idSelectedTheme: [],
      showSelect: false,
      selected_vid: '',
      all_video: [],
      page: 0,
      total_number: 0,
      defaultScreenshot: '/static/images/play_thumbnail.svg',
      indexvideo: '',
      disabledSelectButton: true,
      videoGeneric: {},
      searchTitle: '',
      screenType: '',
      themId: 0,
      options: [],
      textToSearch: '',
    };
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  mixins: [mixin],
  mounted() {
    this.optionSelect();
  },
  props: {
    genericType: {
      type: String,
    },
  },
  created() {
    var self = this;
    self.reloadVideoList(1);
  },

  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters({
      dispositions: 'dispositions/getAll',
      paramsClient: 'getParamsClients',
      getAllSelected: 'segments/getAllSelected',
      getAllSelectedSlides: 'slides/getAllSelected',
      getGenericThem: 'common/getGenericThem',
      getOptionsThemeSelect: 'common/getOptionsThemeSelect',
    }),
  },
  components: {
    InfiniteLoading,
  },
  methods: {
    ...mapActions(['pushScreen']),
    ...mapActions('slides', ['setSlidesGeneric']),
    ...mapActions('segments', [
      'setSegmentsGeneric',
      'setVideoIntro',
      'setSegmentsGenericFinEmpty',
    ]),
    ...mapActions({
      setSelectedVideo: 'common/setSelectedVideo',
      searchGenericVideo: 'common/searchGenericVideo',
    }),
    ...mapActions('common', ['setGenericThem']),
    hasStartGeneric(segment) {
      return segment.screens.some(s => s.type === 'startGeneric');
    },
    duration(duration) {
      return this.getDuration(duration);
    },
    isSelected(video) {
      var generic = document.getElementById('list_videos').getAttribute('generic');
      const index = document.getElementById('list_videos').getAttribute('data-index');
      if (this.$route.name === 'segment') {
        if (generic === 'debut') {
          const startGeneric = this.getAllSelectedSlides.find(s => s.type === 'startGeneric');
          if (startGeneric) {
            this.disabledSelectButton = false;
            return startGeneric.html.indexOf(video.lien) > -1;
          }
        }
      } else {
        if (generic === 'debut') {
          const startGeneric = this.getAllSelected.find(s => s.type === 'startGeneric');
          if (startGeneric) {
            this.disabledSelectButton = false;
            return (
              startGeneric.screens[0].html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                startGeneric.screens[0].html.indexOf(
                  video.lienMp4.substring(0, video.lienMp4.length - 13),
                ) > -1)
            );
          }
        } else if (generic === 'fin') {
          const finishGeneric = this.getAllSelected.find(s => s.type === 'finishGeneric');
          if (finishGeneric) {
            this.disabledSelectButton = false;
            return (
              finishGeneric.screens[0].html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                finishGeneric.screens[0].html.indexOf(
                  video.lienMp4.substring(0, video.lienMp4.length - 13),
                ) > -1)
            );
          }
        } else if (generic === 'intro') {
          const introGeneric = this.getAllSelected[index].screens.find(
            s => s.type === 'startGeneric',
          );
          if (introGeneric) {
            this.disabledSelectButton = false;
            return (
              introGeneric.html.indexOf(video.lien) > -1 ||
              (video.lienMp4 &&
                introGeneric.html.indexOf(video.lienMp4.substring(0, video.lienMp4.length - 13)) >
                  -1)
            );
          }
        }
      }
    },
    SelectVideo(video, index) {
      let videoObj = {
        lien: video.lien,
        lienMp4: video.lienMp4,
        id: video.id,
        logo: video.logo,
        title: video.title,
        duration: video.duration,
      };
      this.videoGeneric = videoObj;
      this.selected_vid = this.videoGeneric.id;
      this.disabledSelectButton = false;

        const videoTag = document.querySelector('.video-tag-' + index);
        videoTag.classList.toggle('is-selected-video');
        if (videoTag.classList.contains('is-selected-video')) {
          this.disabledSelectButton = false;
        } else {
          this.videoGeneric = {};
          this.disabledSelectButton = this.genericType === 'fin' ? false : true;
        }
      if (this.genericType === 'debut') {
        setTimeout(() => {
          this.addGeneriqueVideo();
        }, 100);
      }
    },
    DeselectVideo() {
      let videoObj = {
        lien: '',
        lienMp4: '',
        id: '',
        logo: '',
        title: '',
        duration: '',
      };
      this.videoGeneric = videoObj;
      this.selected_vid = '';
      this.disabledSelectButton = this.genericType === 'fin' ? false : true;
      this.addGeneriqueVideo();
    },
    closeGenericList() {
      eventHub.$emit('eventShowListVideo', false);
    },
    addGeneriqueVideo() {
      var self = this;
      if (this.genericType === 'fin' && !!!this.videoGeneric.lien) {
        this.setSegmentsGenericFinEmpty({ type: 'finishGeneric' });
        self.selected_vid = 0;
        eventHub.$emit('eventShowListVideo', false);
        return;
      }
      if (this.genericType === 'debut' && !!!this.videoGeneric.lien) {

        return;
      }
      var generic = document.getElementById('list_videos').getAttribute('generic');
      const index = document.getElementById('list_videos').getAttribute('data-index');
      let display_default_blocks = this.paramsClient.display_default_blocks;
      let src = this.videoGeneric.lien;
      if (display_default_blocks && display_default_blocks.length > 0) {
        let blocks = display_default_blocks.map(block => {
          return block.blocks;
        });
        blocks.forEach(block => {
          for (let i = 0; i < block.length; i++) {
            if (block[i] === 'video_mp4') {
              src = this.videoGeneric.lienMp4;
            }
          }
        });
      }
      const slide = {
        src: src,
        title: 'generique ' + generic + ' ' + self.makeId(),
        logo: this.videoGeneric.logo,
        options: {
          duration: this.videoGeneric.duration,
        },
        originalDuration: this.videoGeneric.duration,
      };
      if (generic === 'intro') {
        slide.type = 'startGeneric';
        slide.index = index;
        self.setVideoIntro(slide);
      } else {
        if (generic === 'debut') {
          slide.type = 'startGeneric';
        } else {
          slide.type = 'finishGeneric';
        }
        if (self.$route.name === 'segment') {
          self.setSlidesGeneric(slide);
        } else {
          self.setSegmentsGeneric(slide);
        }
      }

      self.selected_vid = this.videoGeneric.id;
      self.$toasted.show(i18n.t('module.generic.success_add'), {
        theme: 'bubble',
        position: 'top-center',
        duration: 4000,
        icon: 'fa-check-circle',
        className: 'save-toast',
      });
      eventHub.$emit('eventShowListVideo', false);
    },

    reloadVideoList() {
      var self = this;
      self.page = self.page + 1;
      let params = {};
      if (this.getGenericThem == 0) {
        params = {
          id: '',
          page: self.page,
          nbParPage: 20,
          client: localStorage.getItem('client'),
        };
      } else {
        this.themeId = this.getGenericThem;
        params = {
          id: '',
          page: self.page,
          nbParPage: 20,
          idTheme: this.themeId,
          client: localStorage.getItem('client'),
          maxBitrate: true,
        };
      }
      if (this.searchTitle) {
        params.searchWord = this.searchTitle;
      }
      HTTP(window.ApiToken)
        .get(Routing.generate('api_media_get_media', params))
        .then(
          function(response) {
            document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
            if (response.data.code === 200) {
              if (response.data) {
                self.total_number = self.total_number + response.data.medias.length;
                self.all_video = self.all_video.concat(response.data.medias);
                var listElm = document.getElementById('list_video');
                listElm.onscroll = function() {
                  if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    if (self.all_video.length < response.data.nombre_total) {
                      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
                      self.reloadVideoList();
                    } else {
                      document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
                    }
                  }
                };
              }
            }
          },
          function(response) {
            //self.hideLoader();
          },
        );
    },
    searchVideo(x) {
      if (x) {
        // title = document.getElementById('inputSearch').value;
        this.searchTitle = this.textToSearch;
        this.page = 0;
        this.all_video = [];
        this.searchGenericVideo(this.searchTitle);
        this.reloadVideoList(this.themeId);
        document.getElementById('loader-liste-dispo').style.visibility = 'visible';
      } else {
        this.textToSearch = '';
        this.searchTitle = '';
        this.page = 0;
        this.all_video = [];
        this.searchGenericVideo(this.searchTitle);
        this.reloadVideoList(this.themeId);
        document.getElementById('loader-liste-dispo').style.visibility = 'hidden';
      }
    },
    btnConfirm() {
      var self = this;
      self.close();
    },

    optionSelect() {
      if (this.getOptionsThemeSelect.length != 0) {
        this.options = this.getOptionsThemeSelect;
        this.idSelectedTheme = this.options[0].id;
        if (this.options.length > 1) this.showSelect = true;
      }
    },
    onChangeThemId() {
      this.setGenericThem(this.idSelectedTheme);
      this.all_video = [];
      this.page = 0;
      this.reloadVideoList();
      document.getElementById('loader-liste-dispo').style.visibility = 'visible';
    },
  },
};
</script>

<style lang="scss" scoped>
#plan1 {
  overflow: auto;
  z-index: 9999;
  padding: 1em 2em;
  filter: blur(0px);
}
.success-dispo {
  background: rgb(59, 151, 227);
  border: none;
  width: 159px;
  height: 47px;
  font-size: larger;
  color: rgb(255, 255, 255);
  border-radius: 3px;
  margin-bottom: 25px;
  margin-top: 20px;
  margin-right: -75%;
  cursor: pointer;
}
.list_video_content {
  text-align: center;
  max-height: 560px;
  overflow-y: scroll;
  padding-top: 20px;
  background: #ffffff;
  padding: 10px 10px !important;
}
.footer-content {
  height: 50px;
  padding: 2rem 1.5rem !important;
}
.list-dispo {
  background: #e3e6ed;
}

.img-liste-dispo {
  width: 204px;
  height: 115px;
  position: relative;
  min-width: 180px;
  overflow: hidden;
  min-width: 100%;
  border-radius: 3px;
  object-fit: cover;
}
.position-buttons {
  position: absolute;
  right: 3em;
  display: flex;
  justify-content: flex-end;
  /* margin-top: 2em; */
  bottom: 1em;
  &__cancel,
  &__finish,
  &__next,
  &__confirm {
    margin: 0 5px !important;
    padding: 0.375rem 2em !important;
  }
}
.video-tag {
  position: relative;
  /*margin: 10px !important;*/
  width: 204px;
  height: 115px;
  text-align: center;
  cursor: pointer;
  /*overflow: hidden;*/
  float: left;
  cursor: pointer;
  border-radius: 3px;
  &:hover {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    background: rgba(26, 147, 240, 0.6);
    .image-card {
      background: rgba(26, 147, 240, 0.6);
      z-index: 1;
      &__infos {
        &__duration {
          z-index: 1;
        }
      }
    }
  }
  &.is-selected-video {
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.16), 2px 4px 6px rgba(0, 0, 0, 0.23);
    .image-card {
      &__infos {
        &__duration {
          z-index: 1;
        }
      }
    }
    &:before {
      background: rgba(26, 147, 240, 0.6);
      z-index: 1;
    }
  }
  &:before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    transition: 0s ease-in-out;
  }
}
.video-wrapper {
  /*flex: 0 0 25%;*/
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 20px 20px 20px 0;
  /*@media screen and (max-width: 1077px) and (min-width: 815px) {*/
  /*flex: 0 0 33.33%;*/
  /*}*/
  /*@media screen and (max-width: 815px) {*/
  /*flex: 0 0 50%;*/
  /*}*/
}
.list_video {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  min-height: 100px;
  max-height: 660px;
  overflow-y: auto;
  overflow-x: hidden;
}
.selected-video {
  background-color: rgba(255, 255, 255, 0.1);
  opacity: 0.6;
}
#search-list {
  width: 100%;
  /* padding-left: 12px; */
  padding: 0;
  margin-bottom: 2%;
  margin: 0 1em;
  &:hover {
    border: 1px;
  }
}
.search-images {
  position: absolute;
  border: none;
  background-color: #ffffff;
  color: #7c7c7c;
  border-color: #7c7c7c;
}
.image-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  &__video {
    width: 100%;
    position: absolute;
    display: flex;
    flex-direction: row;
    top: 0;
  }
  &__infos {
    position: absolute;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 20%;
    bottom: 0;
    &__title {
      float: left;
      text-align: left;
      width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 13px;
      color: white;
      font-weight: bold;
      padding: 0.5em 0;
      bottom: 0;
      color: #707070;
    }
    &__duration {
      float: right;
      right: 0;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      font-size: 12px;
      padding: 2px 3px !important;
      bottom: 8px;
      margin: 0.5em 0;
    }
  }
}
.list-generics {
  width: 100%;
  height: 100%;
  overflow: auto;
  overflow-x: hidden;
  height: 27em;
  max-height: 26.5em;
  height: 40em;
  max-height: 40em;
  border-radius: 2px;
  /*padding: 0.8em;*/
  flex-wrap: wrap;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  .list-generic-videos {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #bebebe;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background: #bebebe;
    border-radius: 5px;
    &:hover {
      background: #b2b2b2;
      height: 10px;
    }
  }
}
@media (max-height: 575px) {
  .list-generics {
    max-height: 18em;
  }
}
@media (max-height: 680px) and (min-height: 575px) {
  .list-generics {
    max-height: 20em;
  }
}
@media (max-height: 850px) and (min-height: 680px) {
  .list-generics {
    max-height: 30em;
  }
}

@media (min-height: 850px) and (max-height: 1300px) {
  .list-generics {
    max-height: 35em;
  }
}
.searchIcon {
  border: 1px solid #ced4da !important;
  border-left: none;
  background-color: #ffffff !important;
  color: #ced4da !important;
  font-size: 13px !important;
  &:focus {
    border: 1px solid #ced4da !important;
  }
}
.searchInput {
  border-right: none;
  font-size: 16px !important;

  &:focus {
    border: 1px solid #ced4da !important;
  }
}
#inputVideoSearch::placeholder {
  font-size: 16px;
}
.search-wrapper-list {
  position: relative;
  text-align: left;
  padding: 5px;

  input {
    padding: 6px 12px;
    color: rgba(0, 0, 0, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.12);
    transition: 0.15s all ease-in-out;
    background: transparent;

    border-radius: 5px;
    &:focus {
      outline: none;
    }
    &::-webkit-input-placeholder {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      font-weight: 100;
    }
  }
}
.footer-select-button {
  padding: 0.5em 2em !important;
  line-height: 1 !important;
  font-size: 14px !important;
  margin: 0 0.5em !important;
}
.flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: start;
}
.duration-style {
  background: #919ba5;
  border-radius: 3px;
  justify-content: center;
  color: #ffffff;
}
#card-add-prog {
  background-color: #ecedf0 !important;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
  margin-bottom: 3% !important;
  width: 100%;
  margin: 0 1em;
}
#card-add-prog .card-body {
  display: flex !important;
}

.text-left {
  text-align: left;
}
.icon-add-prog {
  margin-right: 1em;
}
.lg-btn {
  width: 8em;
}
.search-group {
  display: flex;
  align-items: center !important;

  .inputSearch {
    border-color: #7c7c7c;
    padding: 0 2rem !important;
    border-radius: 0.4rem;
    border-top-left-radius: 0.4rem !important;
    border-bottom-left-radius: 0.4rem !important;
    color: #797a8e;
    font-size: 0.9em;
    @media screen and (min-width: 992px) and (max-width: 1080px) {
      padding: 1.2rem 2.5rem !important;
    }
    @media screen and (max-width: 992px) and (min-width: 765px) {
      padding: 1.2rem 2rem !important;
    }
    @media screen and (max-width: 765px) {
      padding: 1.2rem 2rem !important;
    }
  }
  .close-module-list {
    position: absolute;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    right: 15px;
    top: 0;
    height: 100%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #797a8e;
    cursor: pointer;
    z-index: 4;
  }
  .search-icon {
    cursor: pointer;
    position: absolute;
    z-index: 7;
    display: flex;
    justify-content: center;
    padding: 0 0.5em;
    svg {
      width: 25px;
      height: 100%;
      display: flex;
      justify-content: center;
      path {
        fill: #797a8e;
      }
    }
    @media screen and (min-width: 992px) and (max-width: 1080px) {
      svg {
        width: 20px;
      }
    }
    @media screen and (max-width: 992px) and (min-width: 765px) {
      svg {
        width: 20px;
      }
    }
    @media screen and (max-width: 765px) {
      svg {
        width: 20px;
      }
    }
  }
  .search-button {
    border-right: none !important;
    background-color: #ffffff;
    color: #7c7c7c;
    border-color: #7c7c7c;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ListGenericVideo.vue?030c7632